import { PipeTransform, Pipe } from '@angular/core';
@Pipe({
  name: 'spaceCapCase',
  standalone: false
})
export class SpaceCapCasePipe implements PipeTransform {
  transform(str: string) {
    return spaceCapCase(str);
  }
}

export function spaceCapCase(str: string): string {
  if (!str) {
    return str;
  }
  if (!str.replace) {
    return str; //console.error(str); //was seeing a bool passed in in some circumstances
  }
  return str
    .replace(/([A-Z])(?=[^A-Z])/g, ' $1')
    .replace(/([^A-Za-z ]) (?=[A-Z])/g, '$1')
    .trim()
    .replace(/([0-9])([A-Z])/g, '$1 $2')
    .replace(/([^0-9])([0-9])/g, '$1 $2');
}

export function spaceCapCaseToLower(str: string): string {
  return spaceCapCase(str).toLowerCase();
}
